import React, { Component } from 'react';
import { ClaimDetails }     from 'components/ClaimDetails/ClaimDetails';
import { formatCurrency }   from 'helpers/common.helper';
import moment               from 'moment';

export class AssistantClaimsCards extends Component {
  render() {
    const colorHash   = { 'Approved': 'success', 'Rejected': 'primary', 'Pending Submissions': 'warning', 'Pending Approval': 'grey', 'Paid': 'success' };
    const statusHash  = { 'approved': 'Approved', 'not_submitted': 'Pending Submissions', 'draft': 'Pending Submissions', 'under_review': 'Pending Submissions', 'pending': 'Pending Approval', 'under_approval_review': 'Pending Approval', 'rejected': 'Rejected' };
    const catHash     = { 'general': 'Medical', 'gp': 'Medical', 'specialist': 'Specialist', 'dental': 'Dental', 'optical': 'Optical', 'ehs': 'EHS' };
    const today       = moment().format('DD MMM YYYY');

    const patientCards = this.props.items.map((hash, index) => {
      const displayedStatus = hash.paid ? 'Paid' : statusHash[hash.status];
      const color           = colorHash[displayedStatus];
      const displayedDate   = hash.date === today ? 'Today' : hash.date;
      const category        = catHash[hash.category];
      const actionButton    = <ClaimDetails data={ hash } status={ displayedStatus } color={ color } category={ category } display_address={ true } />;

      return (
        <tr key={ hash.id } className="assistant-claim-card-row bg-white" value={ hash.status }>
          {/* Desktop View */}
            <td valign="top" className={ 'd-none d-lg-table-cell py-6 px-4 border-' + color }>
              <p className="fweight-500 font-size-6 mb-2">{ displayedDate }</p>
              <span className="font-size-4 mb-0">Ref No.: { hash.id }</span>
            </td>

            <td valign="top" className="d-none d-lg-table-cell py-6 pr-4">
              <p className="mb-1 font-size-6 fweight-500">{ hash.practice_location?.doctor_name }</p>
              <p className="mb-0 font-size-5 fweight-400 text-grey">{ hash.practice_location?.name }</p>
            </td>

            <td valign="top" className="d-none d-lg-table-cell py-6 pr-4">
              <p className="mb-1 font-size-6 fweight-500">{ hash.personal_info.policy_owner }</p>
              <p className="mb-0 font-size-5 fweight-400 text-grey">{ hash.personal_info.company_name }</p>
            </td>

            <td valign="top" className="d-none d-lg-table-cell py-6 pr-4">
              <b className={ 'text-' + color }>{ displayedStatus }</b><br/>
              <b>{ 'MYR ' + formatCurrency(hash.total_amount) }</b><br/>
              { category }
            </td>

            <td valign="top" className="d-none d-lg-table-cell py-6 pr-4">{ actionButton }</td>

          {/* Mobile View */}
            <td colSpan="6" valign="top" className={ 'd-table-cell d-lg-none font-size-7 py-6 pl-6 border-' + color }>
              <div className="d-flex justify-content-between mt-2 mb-2">
                <p className="mb-0 flex-grow-1">
                  <b className="d-inline-block w-em-15 font-size-6">{ displayedDate }</b>
                </p>

                <b className={ 'text-right text-' + color}>{ displayedStatus }</b>
                { actionButton }
              </div>

              <p className="mb-1 font-size-6 fweight-500">Doctor</p>
              <p className="mb-1 font-size-5">{ hash.practice_location?.doctor_name }</p>
              <p className="mb-1 font-size-5">{ hash.practice_location?.name }</p>
              <p className="mb-1 font-size-6 fweight-500 mt-4">Patient</p>
              <p className="mb-1 font-size-5">{ hash.personal_info.policy_owner }</p>
              <p className="mb-1 font-size-5">{ hash.personal_info.company_name }</p>

              <div className="d-flex align-items-end justify-content-between mb-0 mr-8 mt-4">
                <div>
                  <span className="d-inline-block w-em-12">Category:</span>
                  <b>{ category }</b><br/>
                  <span className="d-inline-block w-em-12">Total Bill:</span>
                  <b>{ 'MYR ' + formatCurrency(hash.total_amount) }</b>
                </div>

                <span className="font-size-3 mb-0">Ref No.: { hash.id }</span>
              </div>
            </td>
        </tr>
      )
    });

    const emptyHolder   = <tr className="assistant-claim-card-row bg-white">
      <td colSpan="6" className="text-center font-size-7 fweight-500 py-4" style={{ borderRadius: "0.5em" }}>No claims for this search filter</td>
    </tr>;

    const displayCards  = patientCards.length > 0 ? patientCards : emptyHolder;

    return (
      <table id="dashboard-cards-table" className="w-100">
        <thead className="d-none d-lg-table-header-group">
          <tr>
            {
              ['Date', 'Doctor', 'Patient Profile', 'Info', 'Actions'].map((name, index) => {
                const padding = index > 0 ? 'pr-4' : 'px-4';
                return <th key={ 'table-header-' + name } className={ "font-size-7 fweight-500 " + padding }>{ name }</th>
              })
            }
          </tr>
        </thead>

        <tbody>
          { displayCards }
        </tbody>
      </table>
    )
  }
}